export default __webpack_public_path__ + "b5322c7aa3e3f77a0726a641a1339ddd.woff2";